module.exports = require("./shi-Latn-MA.js");